export enum MobileStore {
  GOOGLE_PLAY = 'google-play',
  APP_STORE = 'app-store',
}
